
import React from 'react';

const Accountability = ({ people }) => {
    return (
        <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col">
            <h3 className="text-sm font-bold text-gray-900 mb-4">Accountability</h3>

            <div className="flex flex-col gap-3 overflow-y-auto pr-1 min-h-[100px] max-h-[340px]">
                {people && people.length > 0 ? (
                    people.map((person) => (
                        <div key={person.id} className="bg-gray-200 rounded-lg p-3 flex items-center gap-3 shrink-0">
                            <div className="w-10 h-10 rounded-full bg-[#1F4B55] flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                                {/* {person.initials} */}
                                {person.name?.substring(0, 2)?.toUpperCase()}
                            </div>
                            <div className="flex flex-col">
                                {/* person.role is an object {id, name} in API, so we need person.role.name */}
                                <span className="text-xs text-gray-600">{person.designation?.name || person.role?.name || person.role}</span>
                                <span className="text-sm font-bold text-gray-900">{person.name}</span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center h-full py-8 px-4">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-orange-50 to-amber-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-orange-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            No Active Staff
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            Team members working today will be displayed here once they are assigned.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Accountability;
